import { getCurrentGatewayUrl } from './environmentDetection';
import { resolveMcpOAuthGatewayOrigin } from './resolveMcpOAuthGatewayOrigin';

export const buildMcpOAuthAuthorizeQuery = async () => {
  const desktopScheme =
    await window.electronAPI?.mcpOAuth?.getCallbackScheme?.();

  let electronGatewayUrl: string | null = null;
  if (window.electronAPI?.domain?.get) {
    try {
      const domainState = await window.electronAPI.domain.get();
      electronGatewayUrl = domainState.urls.gatewayUrl ?? null;
    } catch {
      electronGatewayUrl = null;
    }
  }

  const { gatewayOrigin } = resolveMcpOAuthGatewayOrigin({
    configuredGatewayUrl: getCurrentGatewayUrl(),
    electronGatewayUrl,
  });

  return {
    openerOrigin: window.location.origin,
    gatewayOrigin,
    desktopScheme,
    callbackPath: '/en/auth/mcp/oauth-callback',
  };
};
